import React, { useEffect } from "react"
import "../styles/app.scss"
import {
  MainLayout,
  LinksProp,
  GraphQLData,
  Demo,
  BlogPostFrontmatter,
} from "@wp/ui"
import SEO from "./seo"
import { Helmet } from "react-helmet"
import Logo from "../img/logo.inline.svg"
import Mark from "../img/mark.inline.svg"
import magazineImg from "../img/Writers-Print (4).png"
import minimalImg from "../img/Writers-Print (3).png"
import lifestyleImg from "../img/Writers-Print (5).png"
import photographyImg from "../img/Writers-Print (2).png"
import useSiteMetadata from "./SiteMetadata"
import { useStaticQuery, graphql } from "gatsby"

type LayoutComponent = {
  title?: string
  withFooter?: boolean
}

const Layout: React.FC<LayoutComponent> = ({
  children,
  withFooter = true,
  title = "",
}) => {
  const siteMetadata = useSiteMetadata()

  const data: GraphQLData<BlogPostFrontmatter> = useStaticQuery(graphql`
    query {
      allMarkdownRemark(
        sort: { order: DESC, fields: [frontmatter___date] }
        filter: { frontmatter: { templateKey: { eq: "blog-post" } } }
      ) {
        edges {
          node {
            excerpt(pruneLength: 400)
            id
            fields {
              slug
            }
            frontmatter {
              title
              templateKey
              date(formatString: "MMMM DD, YYYY")
              featuredpost
              description
              image {
                childImageSharp {
                  fluid(maxWidth: 1200, quality: 100) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  const { edges } = data.allMarkdownRemark

  // Check device type
  useEffect(() => {
    if (
      /iPhone|iPad|Android|Blackberry|iPod/.test(window.navigator.userAgent)
    ) {
      document.querySelector("body").classList.add("ismobile")
      document.querySelector("body").classList.remove("isnotmobile")
    } else {
      document.querySelector("body").classList.remove("ismobile")
      document.querySelector("body").classList.add("isnotmobile")
    }
    document.body.style.overflow = "unset"
    // document.cookie = "SameSite=None; promo_shown=1; Max-Age=2600000; Secure"
  }, [])

  const pageLinks: LinksProp[] = [
    { name: "Home", to: "/" },
    { name: "About", to: "/about" },
    { name: "Contact", to: "/contact" },
    { name: "404", to: "/404" },
  ]

  return (
    <>
      <SEO title={title} />
      <Helmet>
        <link
          href="https://fonts.googleapis.com/css2?family=DM+Serif+Text&family=Lora:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,300;1,400;1,600;1,700;1,800&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <MainLayout
        pageLinks={pageLinks}
        siteMetadata={siteMetadata}
        logo={Logo}
        posts={edges}
        withFooter={withFooter}
        footerLogo={Mark}
      >
        {children}
      </MainLayout>
      <Demo
        demos={[
          { img: minimalImg, url: "djf", title: "Minimal" },
          { img: photographyImg, url: "djf", title: "Photography" },
          { img: lifestyleImg, url: "djf", title: "Lifestyle" },
          { img: magazineImg, url: "djf", title: "Magazine" },
        ]}
      />
    </>
  )
}

export default Layout
